export const ItemStatusEnum = Object.freeze({
    Normal: "NORMAL",
    Completed: "COMPLETED",
    Upcoming: "UPCOMING",
    Overdue: "OVERDUE"
});
